import { OnDestroy } from '@angular/core';
import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { version } from 'mobile-detect';
import { WorkspaceServiceService } from '../../services/workspace-service.service';

@Component({
  selector: 'mobile-toolbar',
  template: require('./mobile-toolbar.component.html'),
  styles: [require('./mobile-toolbar.component.css')]
})
export class MobileToolbarComponent implements OnInit, OnDestroy {
  static DEFAULT_MOBILE_TOOLBAR_HEIGHT = '56px';

  @HostBinding('style.height')
  protected _height?: string;

  @Input()
  asContainer = false;

  @Input()
  autosetPaddingTop = true;
  
  @Input()
  set height(value: string | undefined)
  {
    if(this._height == value)
      return;

    this._height = value;
    this.heightChanged.emit(value);
    try
    {
      if(this.autosetPaddingTop)
        this.elementRef.nativeElement.parentElement.style.paddingTop = value;
    }
    catch(e)
    {
      console.log(e);
      (window as any).toolbarF = this;
    }
  }

  @Input()
  title = '';

  @Input()
  showBack= true;

  @Input()
  showHome= false;

  @Input()
  showDone = false;

  @Input()
  homeShowsLandingPage = true;

  @Output()
  heightChanged: EventEmitter<string | undefined> = new EventEmitter();

  @Output()
  back = new EventEmitter<Event>()

  @Output()
  done = new EventEmitter<Event>()

  @Output()
  home = new EventEmitter<Event>();

  constructor(protected elementRef: ElementRef, protected workspaceService: WorkspaceServiceService) 
  { 
  }

  ngOnInit() 
  {
    if(this._height == undefined) 
      this.height = MobileToolbarComponent.DEFAULT_MOBILE_TOOLBAR_HEIGHT;
  }

  homeButtonClicked(event: Event)
  {
    if(this.homeShowsLandingPage)
      this.workspaceService.data.showMobileLandingPage = true;

    this.home.emit(event);
  }

  backButtonClicked(event: Event)
  {
    this.back.emit(event);
  }

  doneButtonClicked(event: Event)
  {
    this.done.emit(event);
  }

  ngOnDestroy (): void {
    this.height = '0px';
  }

}
